<template>
  <div class="add-weekday-table">
    <v-row>
      <v-col cols="10">
        <data-table-weekday
          ref="dataTableWeekday"
          :data="weekday"
          :hideActions="isActive || isExpired || !auth.isParkmanAdmin()"
          @update="updateWeekdayPrice"
          @delete="deleteWeekdayPrice"
          @submit="addWeekdayPrice"
          :showCopyPaste="showCopyPasteWeekday"
          :canPaste="canPasteWeekday"
          :pasteLoading="pasteWeekdayLoading"
          @copy="$emit('copyWeekday')"
          @paste="$emit('pasteWeekday')"
        />
      </v-col>
    </v-row>

    <v-row no-gutters class="gap-x-2">
      <v-col cols="5" class="pr-2">
        <data-table-sequence
          :data="sequence"
          :hideActions="isActive || isExpired || !auth.isParkmanAdmin()"
          :showCopyPaste="showCopyPasteSequence"
          :canPaste="canPasteSequence"
          :pasteLoading="pasteSequenceLoading"
          @copy="$emit('copySequence')"
          @paste="$emit('pasteSequence')"
          @submit="addSequencePrice"
          @update="updateSequencePrice"
          @delete="deleteSequencePrice"
        />
      </v-col>
      <v-col cols="5" class="pr-1">
        <data-table-apply-sequence
          :data="sequencePeriod"
          :hideActions="isActive || isExpired || !auth.isParkmanAdmin()"
          :showCopyPaste="showCopyPasteSequencePeriod"
          :canPaste="canPasteSequencePeriod"
          :pasteLoading="pasteSequencePeriodLoading"
          @copy="$emit('copySequencePeriod')"
          @paste="$emit('pasteSequencePeriod')"
          @submit="addSequencePricePeriod"
          @update="updateSequencePeriod"
          @delete="deleteSequencePricePeriod"
        />
      </v-col>  
    </v-row>

    <v-row class="gap-x-2">
      <v-col cols="5" class="pr-1">
        <data-table-periodic
          :data="periodic"
          :hideActions="isActive || isExpired || !auth.isParkmanAdmin()"
          :showCopyPaste="showCopyPastePeriodic"
          :canPaste="canPastePeriodic"
          :pasteLoading="pastePeriodicLoading"
          @copy="$emit('copyPeriodic')"
          @paste="$emit('pastePeriodic')"
          @submit="addPeriodicPrice"
          @update="updatePeriodic"
          @delete="deletePeriodic"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import auth from '@/auth'
import DataTableWeekday from '@/components/Locations/AddVisitorParking/DataTable/DataTableWeekday'
import DataTableSequence from '@/components/Locations/AddVisitorParking/DataTable/DataTableSequence'
import DataTablePeriodic from '@/components/Locations/AddVisitorParking/DataTable/DataTablePeriodic'
import DataTableApplySequence from '@/components/Locations/AddVisitorParking/DataTable/DataTableApplySequence'
import { mapGetters } from 'vuex'

export default {
  name: 'PricingSchedule',
  components: {
    DataTableWeekday,
    DataTableSequence,
    DataTablePeriodic,
    DataTableApplySequence
  },
  props: {
    weekday: {
      type: Array
    },
    sequence: {
      type: Array
    },
    periodic: {
      type: Array
    },
    isActive: {
      type: Boolean
    },
    isExpired: {
      type: Boolean
    },
    closeDataTableWeekdayPopup: {
      type: Boolean
    },
    sequencePeriod: {
      type: Array
    },
    showCopyPasteWeekday: { type: Boolean, default: false },
    canPasteWeekday: { type: Boolean, default: false },
    pasteWeekdayLoading: { type: Boolean, default: false },
    showCopyPasteSequence: { type: Boolean, default: false },
    canPasteSequence: { type: Boolean, default: false },
    pasteSequenceLoading: { type: Boolean, default: false },

    showCopyPasteSequencePeriod: { type: Boolean, default: false },
    canPasteSequencePeriod: { type: Boolean, default: false },
    pasteSequencePeriodLoading: { type: Boolean, default: false },

    showCopyPastePeriodic: { type: Boolean, default: false },
    canPastePeriodic: { type: Boolean, default: false },
    pastePeriodicLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      auth: auth
    }
  },
  watch: {
    closeDataTableWeekdayPopup() {
      this.$refs.dataTableWeekday.close()
    }
  },
  computed: {
    ...mapGetters(['currentLocation']),
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint
    }
  },
  methods: {
    updateWeekdayPrice(item) {
      this.$emit('updateWeekDay', item)
    },
    deleteWeekdayPrice(item) {
      this.$emit('deleteWeekDay', item)
    },
    addWeekdayPrice(item) {
      this.$emit('addWeekDay', item)
    },
    addSequencePrice(item) {
      item.step_index = this.sequence.length + 1
      this.$emit('addSequence', item)
    },
    updateSequencePrice(item) {
      this.$emit('updateSequence', item)
    },
    deleteSequencePrice(item) {
      this.$emit('deleteSequence', item)
    },
    addSequencePricePeriod(item) {
      this.$emit('addSequencePeriod', item)
    },
    deleteSequencePricePeriod(item) {
      this.$emit('deleteSequencePeriod', item)
    },
    updateSequencePeriod(item) {
      this.$emit('updateSequencePeriod', item)
    },
    addPeriodicPrice(item) {
      this.$emit('addPeriodic', item)
    },
    updatePeriodic(item) {
      this.$emit('updatePeriodic', item)
    },
    deletePeriodic(item) {
      this.$emit('deletePeriodic', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/common';

.add-weekday-table {
  padding-top: 12px !important;
}
</style>

<style lang="scss">
.clickable {
  img {
    width: 24px;
    height: 24px;
  }
}
.v-text-field.v-text-field--enclosed.v-text-field--single-line
  .v-text-field__suffix {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  padding-left: 0;
}
</style>
